import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  // Switch,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import { baseURL } from "../../../util/config";
import { setToast } from "../../../util/toast";
import HandleButton from "../../extra/Button";
import {
  createAttribute,
  updateAttribute
} from "../../store/attribute/attribute.action";
import { getCategory } from "../../store/category/category.action";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { getCategoryWiseSubCategory } from "../../store/subCategory/subCategory.action";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 46,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(20px)",
      "& + .MuiSwitch-track": {
        backgroundColor: "#b93160",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#fff",
    width: 18,
    height: 18,
    boxShadow: "none",
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#cccccc",
    borderRadius: 26 / 2,
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const PREDEFINED_COLORS = [
  { name: "Black", code: "#000000" },
  { name: "White", code: "#FFFFFF" },
  { name: "Red", code: "#FF0000" },
  { name: "Lime", code: "#00FF00" },
  { name: "Blue", code: "#0000FF" },
  { name: "Yellow", code: "#FFFF00" },
  { name: "Cyan", code: "#00FFFF" },
  { name: "Magenta", code: "#FF00FF" },
  { name: "Silver", code: "#C0C0C0" },
  { name: "Gray", code: "#808080" },
  { name: "Maroon", code: "#800000" },
  { name: "Olive", code: "#808000" },
  { name: "Green", code: "#008000" },
  { name: "Purple", code: "#800080" },
  { name: "Teal", code: "#008080" },
  { name: "Navy", code: "#000080" },
  { name: "Orange", code: "#FFA500" },
  { name: "Pink", code: "#FFC0CB" },
  { name: "Brown", code: "#A52A2A" },
  { name: "Gold", code: "#FFD700" },
  { name: "Beige", code: "#F5F5DC" },
  { name: "Lavender", code: "#E6E6FA" },
  { name: "Plum", code: "#DDA0DD" },
  { name: "Turquoise", code: "#40E0D0" },
  { name: "Coral", code: "#FF7F50" },
  { name: "Salmon", code: "#FA8072" },
  { name: "Crimson", code: "#DC143C" },
  { name: "Indigo", code: "#4B0082" },
  { name: "Khaki", code: "#F0E68C" }
];

const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

const getClosestColorName = (hex) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return "Color";
  let minDistance = Infinity;
  let closestColor = PREDEFINED_COLORS[0];
  PREDEFINED_COLORS.forEach((color) => {
    const colorRgb = hexToRgb(color.code);
    const distance = Math.sqrt(
      Math.pow(rgb.r - colorRgb.r, 2) +
      Math.pow(rgb.g - colorRgb.g, 2) +
      Math.pow(rgb.b - colorRgb.b, 2)
    );
    if (distance < minDistance) {
      minDistance = distance;
      closestColor = color;
    }
  });
  return closestColor.name;
};

const customStyles = {
  control: (base) => ({
    ...base,
    borderRadius: 8,
    minHeight: 48,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#ffccde' : 'white',
    color: state.isSelected ? 'white' : 'black',
    background: state.isSelected ? '#b93160' : undefined,
    cursor: 'pointer',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};


const AttributeDialog = () => {
  const dialogueDataFromStore = useSelector(
    (state) => state.dialogue.dialogueData
  );

  // For temporary testing override
  const dialogueData = dialogueDataFromStore ?? true; // fallback to true if undefined

  console.log("dialogueData_color_picker", dialogueData);

  const { subcategory } = useSelector((state) => state.attribute);

  const { category } = useSelector((state) => state.category);
  const { categoryWiseSubCategory } = useSelector((state) => state.subCategory);

  const dispatch = useDispatch();


  const [selectedcategoryOptions, setSelectedCategoryOptions] = useState('');
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [mongoId, setMongoId] = useState("");
  const [name, setName] = useState("");
  const [fieldType, setFieldType] = useState("");
  const [fieldValues, setFieldValues] = useState([]);
  const [icon, setIcon] = useState(null);
  const [isRequired, setIsRequired] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isColor, setIsColor] = useState(false);
  const [showAllColors, setShowAllColors] = useState(false);
  const [preview, setPreview] = useState("");

  const [selectedColorCode, setSelectedColorCode] = useState("#FF0000");
  const [selectedColorName, setSelectedColorName] = useState("Red");

  const [error, setError] = useState({
    category: "",
    subcategories: "",
    name: "",
    fieldType: "",
    fieldValues: "",
    icon: "",
  });

  const [originalData, setOriginalData] = useState(null);

  useEffect(() => {
    if (!dialogueData) return;

    const currentOriginalData = {};

    const catOpt = dialogueData?.subCategory?.category
      ? {
        value: dialogueData.subCategory?.category._id,
        label: dialogueData.subCategory?.category.name,
      }
      : "";
    setSelectedCategoryOptions(catOpt);
    currentOriginalData.category = catOpt;

    const subcatOpt = dialogueData?.subCategory
      ? [
        {
          value: dialogueData.subCategory._id,
          label: dialogueData.subCategory.name,
        },
      ]
      : [];
    setSelectedOptions(subcatOpt);
    currentOriginalData.subcategories = subcatOpt;

    const attr = dialogueData?.attributes?.[0];
    setMongoId(attr?._id || "");

    const initName = attr?.name || "";
    setName(initName);
    currentOriginalData.name = initName;

    const initFieldType = attr?.fieldType?.toString() || "";
    setFieldType(initFieldType);
    currentOriginalData.fieldType = initFieldType;

    // Determine if it is a color field based on attr.isColor, name, or existing values
    const fieldName = attr?.name?.trim()?.toLowerCase();
    const hasColorValues = attr?.values?.some(v =>
      typeof v === "string" && (v.startsWith("#") || v.match(/\((#[0-9a-fA-F]{3,6})\)/))
    );
    const isColorField = attr?.isColor || (fieldName === "color" || fieldName === "colors" || hasColorValues);
    setIsColor(isColorField);
    currentOriginalData.isColor = isColorField;

    let initValues = [];
    if (["4", "5", "6"].includes(attr?.fieldType?.toString())) {
      initValues = attr?.values?.map((v) => {
        if (isColorField) {
          const match = v.match(/\((#[0-9a-fA-F]{3,6})\)/);
          const cleanVal = match ? match[1] : v;
          return { value: cleanVal, label: cleanVal };
        }
        return { value: v, label: v };
      }) || [];
      setFieldValues(initValues);
    } else {
      setFieldValues([]);
    }
    currentOriginalData.fieldValues = initValues;

    const initIcon = attr?.image ? baseURL + attr.image : null;
    setIcon(initIcon);
    setPreview(attr?.image ? baseURL + attr.image : "");
    currentOriginalData.icon = initIcon;

    const initReq = attr?.isRequired || false;
    setIsRequired(initReq);
    currentOriginalData.isRequired = initReq;

    const initAct = attr?.isActive || false;
    setIsActive(initAct);
    currentOriginalData.isActive = initAct;

    if (attr?._id) {
      setOriginalData(currentOriginalData);
    } else {
      setOriginalData(null);
    }
  }, [dialogueData]);

  const categoryOptions = category.map((item) => ({
    value: item._id,
    label: item.name,
  }));


  const options = categoryWiseSubCategory.map((item) => ({
    value: item.subCategoryId,
    label: item.name,
  }));

  const handleChangeCategory = (selected) => {
    setSelectedCategoryOptions(selected);
    setSelectedOptions([]); // Clear subcategories selection when category changes
    if (error.category) {
      setError((prev) => ({ ...prev, category: "" }));
    }
  }

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    if (error.subcategories) {
      setError((prev) => ({ ...prev, subcategories: "" }));
    }
  };

  useEffect(() => {
    dispatch(getCategory());
    // dispatch(getAllSubcategory());
  }, [dispatch]);

  useEffect(() => {
    if (selectedcategoryOptions !== "") {
      dispatch(getCategoryWiseSubCategory(selectedcategoryOptions?.value));
    }
  }, [dispatch, selectedcategoryOptions]);

  const validateForm = () => {
    let newErrors = {
      category: "",
      subcategories: "",
      name: "",
      fieldType: "",
      fieldValues: "",
      icon: "",
    };
    let isValid = true;
    if (!selectedcategoryOptions || selectedcategoryOptions.length === 0) {
      newErrors.category = "Please select at least one category.";
      isValid = false;
    }
    if (!selectedOptions || selectedOptions.length === 0) {
      newErrors.subcategories = "Please select at least one subcategory.";
      isValid = false;
    }
    if (!name || !name.trim()) {
      newErrors.name = "Field name is required.";
      isValid = false;
    }
    if (!fieldType) {
      newErrors.fieldType = "Please select a field type.";
      isValid = false;
    }
    if (["4", "5", "6"].includes(fieldType)) {
      if (!fieldValues || fieldValues.length === 0) {
        newErrors.fieldValues = "Please provide at least one field value.";
        isValid = false;
      }
    }
    if (!icon) {
      newErrors.icon = "Please upload an icon image.";
      isValid = false;
    }
    setError(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    const isChoiceType = ["4", "5", "6"].includes(fieldType);
    const formData = new FormData();

    if (mongoId && originalData) {
      let isChanged = false;
      formData.append("attributeId", mongoId);

      if (name.trim() !== originalData.name) {
        formData.append("name", name.trim());
        isChanged = true;
      }

      if (fieldType !== originalData.fieldType) {
        formData.append("fieldType", Number(fieldType));
        isChanged = true;
      }

      if (isRequired !== originalData.isRequired) {
        formData.append("isRequired", isRequired);
        isChanged = true;
      }

      if (isActive !== originalData.isActive) {
        formData.append("isActive", isActive);
        isChanged = true;
      }

      if (isChoiceType) {
        const currentValsStr = fieldValues.map((v) => v.value).sort().join(",");
        const originalValsStr = originalData.fieldValues.map((v) => v.value).sort().join(",");
        if (currentValsStr !== originalValsStr || fieldType !== originalData.fieldType) {
          fieldValues.forEach((v) => {
            formData.append("values", v.value);
          });
          isChanged = true;
        }
      }

      if (icon !== originalData.icon) {
        if (icon && typeof icon !== "string") {
          formData.append("image", icon);
          isChanged = true;
        }
      }

      if (!isChanged) {
        setToast("info", "No changes made");
        dispatch({ type: CLOSE_DIALOGUE });
        return;
      }

      dispatch(updateAttribute(formData));
      dispatch({ type: CLOSE_DIALOGUE });
      return;
    }

    formData.append("name", name.trim());
    formData.append("fieldType", Number(fieldType));
    formData.append("isRequired", isRequired);
    formData.append("isActive", isActive);
    formData.append("type", 1);

    if (isChoiceType) {
      fieldValues.forEach((v) => {
        formData.append("values", v.value);
      });
    }

    if (selectedOptions.length > 0) {
      selectedOptions.forEach((item) => {
        formData.append("subCategoryIds[]", item.value);
      });
    }

    if (icon && typeof icon !== "string") {
      formData.append("image", icon);
    }

    dispatch(createAttribute(formData));
    dispatch({ type: CLOSE_DIALOGUE });
  };

  useEffect(() => {
    return () => {
      if (
        preview &&
        typeof preview === "string" &&
        preview.startsWith("blob:")
      ) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  return (
    <Dialog
      open={Boolean(dialogueData)}
      onClose={() => dispatch({ type: CLOSE_DIALOGUE })}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "18px",
          width: "600px",
          maxWidth: "100vw",
          padding: "6px 5px",
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h5" component="span">
          {mongoId ? "  " : "Create Attribute"}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} sx={{ mt: 1 }}>


            {/* category */}

            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 0.5 }}>
                Select Category
              </Typography>
              <Select
                options={categoryOptions}
                value={selectedcategoryOptions}
                onChange={handleChangeCategory}
                placeholder="Select Category..."
                isDisabled={Boolean(mongoId)} // Disable when editing
                styles={customStyles}
              />
              {error.category && (
                <Typography variant="caption" color="error">
                  {error.category}
                </Typography>
              )}
            </Grid>



            {/* category */}

            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 0.5 }}>
                Select Subcategories
              </Typography>
              {/* <Select
                isMulti
                options={options}
                value={selectedOptions}
                onChange={handleChange}
                placeholder="Select subcategories..."
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: 8,
                    minHeight: 48,
                  }),
                }}
              /> */}

              <Select
                isMulti
                options={options}
                value={selectedOptions}
                onChange={handleChange}
                placeholder="Select subcategories..."
                isDisabled={Boolean(mongoId)} // Disable when editing
                styles={{
                  menu: (base) => ({
                    ...base,
                    backgroundColor: '#fff',
                    zIndex: 100,
                  }),
                  multiValue: (base) => ({
                    ...base,
                    backgroundColor: '#b93160',
                    borderRadius: 20,
                    padding: '0 6px 0 12px',
                    display: 'flex',
                    alignItems: 'center',
                  }),
                  multiValueLabel: (base) => ({
                    ...base,
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: '1rem',
                    padding: '2px 8px 2px 0',
                  }),
                  multiValueRemove: (base) => ({
                    ...base,
                    backgroundColor: '#fff',
                    color: '#b93160',
                    borderRadius: '50%',
                    minWidth: 22,
                    minHeight: 22,
                    width: 22,
                    height: 22,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: 5,
                    boxShadow: '0 1px 4px rgba(185,49,96,0.09)',
                    border: 'none',
                    fontSize: 18,
                    cursor: 'pointer',
                    padding: 0,
                    transition: 'all 0.1s',
                  }),
                  control: (base) => ({
                    ...base,
                    borderRadius: 8,
                    minHeight: 48,
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused ? '#ffccde' : 'white',
                    color: state.isSelected ? 'white' : 'black',
                    background: state.isSelected ? '#b93160' : undefined,
                    cursor: 'pointer',
                  }),
                }}

              />

              {error.subcategories && (
                <Typography variant="caption" color="error">
                  {error.subcategories}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Field Name"
                value={name}
                fullWidth
                onChange={(e) => {
                  setName(e.target.value);
                  if (error.name) setError((prev) => ({ ...prev, name: "" }));
                }}
                error={Boolean(error.name)}
                helperText={error.name}
                sx={{
                  borderRadius: 1,
                  // Root for input style
                  '& .MuiOutlinedInput-root': {
                    // Border color (default)
                    '& .MuiOutlinedInput-notchedOutline': {
                      // borderColor: "#b93160",
                    },
                    // Border color (hover)
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: "#b93160",
                    },
                    // Border color (focused)
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: "#b93160",
                    },
                  },
                  // Label color (default & focused)
                  '& .MuiInputLabel-outlined': {
                    // color: "#b93160",
                  },
                  '& .MuiInputLabel-outlined.Mui-focused': {
                    color: "#b93160",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                label="Field Type"
                value={fieldType}
                fullWidth
                onChange={(e) => {
                  setFieldType(e.target.value);
                  if (error.fieldType)
                    setError((prev) => ({ ...prev, fieldType: "" }));
                }}
                error={Boolean(error.fieldType)}
                helperText={error.fieldType}
                sx={{
                  borderRadius: 1,
                  // Root for input style
                  '& .MuiOutlinedInput-root': {
                    // Border color (default)
                    '& .MuiOutlinedInput-notchedOutline': {
                      // borderColor: "#b93160",
                    },
                    // Border color (hover)
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: "#b93160",
                    },
                    // Border color (focused)
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: "#b93160",
                    },
                  },
                  // Label color (default & focused)
                  '& .MuiInputLabel-outlined': {
                    // color: "#b93160",
                  },
                  '& .MuiInputLabel-outlined.Mui-focused': {
                    color: "#b93160",
                  },
                }}
              >
                <MenuItem value="5">Dropdown</MenuItem>
                <MenuItem value="6">Checkboxes</MenuItem>
              </TextField>
            </Grid>
            {["4", "5", "6"].includes(fieldType) && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <CustomSwitch
                      checked={isColor}
                      onChange={() => setIsColor(!isColor)}
                    />
                  }
                  label="Enable this to select color attributes"
                />
              </Grid>
            )}
            {["4", "5", "6"].includes(fieldType) && (
              <Grid item xs={12}>
                {isColor ? (
                  <>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      Select Colors
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                      <input
                        type="color"
                        value={selectedColorCode}
                        onChange={(e) => {
                          setSelectedColorCode(e.target.value);
                          setSelectedColorName(getClosestColorName(e.target.value));
                        }}
                        style={{
                          width: '40px',
                          height: '40px',
                          padding: '0',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                      />
                      <TextField
                        size="small"
                        label="Color Name"
                        value={selectedColorName}
                        onChange={(e) => {
                          const newName = e.target.value;
                          setSelectedColorName(newName);
                          const matchingColor = PREDEFINED_COLORS.find(c => c.name.toLowerCase() === newName.trim().toLowerCase());
                          if (matchingColor) {
                            setSelectedColorCode(matchingColor.code);
                          } else if (/^#[0-9A-F]{6}$/i.test(newName.trim())) {
                            setSelectedColorCode(newName.trim());
                          }
                        }}
                        sx={{ width: '150px' }}
                      />
                      <Button
                        variant="contained"
                        onClick={() => {
                          if (!selectedColorName || !selectedColorCode) return;
                          const val = selectedColorCode;
                          if (!fieldValues.find((v) => v.value === val)) {
                            setFieldValues([...fieldValues, { value: val, label: val }]);
                            if (error.fieldValues) setError((prev) => ({ ...prev, fieldValues: "" }));
                          }
                        }}
                        sx={{
                          backgroundColor: '#b93160',
                          '&:hover': {
                            backgroundColor: '#9a2850'
                          }
                        }}
                      >
                        Add Color
                      </Button>
                    </Box>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {fieldValues.slice(0, showAllColors ? fieldValues.length : 5).map((v, index) => {
                        const chipColor = (v.value && v.value.startsWith('#')) ? v.value : (v.value.match(/\((#[0-9a-fA-F]{3,6})\)/)?.[1] || '#ccc');
                        const displayName = v.value.startsWith('#') ? `${getClosestColorName(v.value)} (${v.value})` : v.value;

                        return (
                          <Box
                            key={index}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              backgroundColor: '#f1f1f1',
                              padding: '4px 12px 4px 6px',
                              borderRadius: '20px',
                              border: '1px solid #ddd'
                            }}
                          >
                            <Box sx={{ width: 16, height: 16, borderRadius: '50%', backgroundColor: chipColor, border: '1px solid #aaa' }} />
                            <Typography variant="body2">{displayName}</Typography>
                            <Box
                              component="span"
                              sx={{
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                marginLeft: '4px',
                                fontSize: '18px',
                                '&:hover': { color: '#b93160' }
                              }}
                              onClick={() => {
                                setFieldValues(fieldValues.filter((item) => item.value !== v.value));
                              }}
                            >
                              &times;
                            </Box>
                          </Box>
                        );
                      })}
                      {fieldValues.length > 5 && (
                        <Box
                          onClick={() => setShowAllColors(!showAllColors)}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#b93160',
                            color: '#fff',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            fontSize: '0.875rem',
                            fontWeight: 'bold',
                            '&:hover': { backgroundColor: '#9a2850' }
                          }}
                        >
                          {showAllColors ? "Show Less" : `+ ${fieldValues.length - 5} More`}
                        </Box>
                      )}
                    </Box>
                    {error.fieldValues && (
                      <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                        {error.fieldValues}
                      </Typography>
                    )}
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                      This will be applied only for: <strong>Checkboxes</strong> and{" "}
                      <strong>Dropdown</strong>.
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      Field Values
                    </Typography>
                    <CreatableSelect
                      isMulti
                      value={fieldValues}
                      onChange={(newValues) => {
                        setFieldValues(newValues);
                        if (error.fieldValues) setError((prev) => ({ ...prev, fieldValues: "" }));
                      }}
                      placeholder="Type and press enter..."
                      styles={{
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: '#b93160',
                          borderRadius: 20,
                          padding: '0 6px 0 12px',
                          display: 'flex',
                          alignItems: 'center'
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: '#fff',
                          fontWeight: 700,
                          fontSize: '1rem',
                          padding: '2px 8px 2px 0',
                        }),
                        multiValueRemove: (base) => ({
                          ...base,
                          backgroundColor: '#fff',
                          color: '#b93160',
                          borderRadius: '50%',
                          minWidth: 22,
                          minHeight: 22,
                          width: 22,
                          height: 22,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginLeft: 5,
                          boxShadow: '0 1px 4px rgba(185,49,96,0.09)',
                          border: 'none',
                          fontSize: 18,
                          cursor: 'pointer',
                          padding: 0,
                          transition: 'all 0.1s',
                        }),
                      }}
                    />
                    {error.fieldValues && (
                      <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                        {error.fieldValues}
                      </Typography>
                    )}
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                      This will be applied only for: <strong>Checkboxes</strong> and{" "}
                      <strong>Dropdown</strong>.
                    </Typography>
                  </>
                )}
              </Grid>
            )}
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" gutterBottom>
                Attribute Icon
              </Typography>
              <Box
                sx={{
                  width: 100,
                  height: 100,
                  borderRadius: 1,
                  border: "1px dashed",
                  borderColor: "divider",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  position: "relative",
                  mb: 1,
                  mt: 1,
                }}
              >
                {preview ? (
                  <>
                    <img
                      src={preview}
                      alt="Attribute Icon"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/defaultImage.png';
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        opacity: 0,
                        transition: "opacity 0.2s",
                        cursor: "pointer",
                        "&:hover": { opacity: 1 },
                      }}
                    >
                      <Typography
                        variant="caption"
                        color="white"
                        align="center"
                      >
                        Click to change
                      </Typography>
                    </Box>
                  </>
                ) : (
                  <PhotoCameraIcon color="action" />
                )}
                <input
                  type="file"
                  accept="image/*"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    opacity: 0,
                    cursor: "pointer",
                  }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setIcon(file);
                      const objectUrl = URL.createObjectURL(file);
                      setPreview(objectUrl);
                    }
                    if (error.icon) setError((prev) => ({ ...prev, icon: "" }));
                  }}
                />
              </Box>
              <Button
                variant="outlined"
                startIcon={<PhotoCameraIcon />}
                component="label"
                size="small"
                sx={{ width: "fit-content", mb: 2 }}
              >
                {preview ? "Change Icon" : "Upload Icon"}
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setIcon(file);
                      const objectUrl = URL.createObjectURL(file);
                      setPreview(objectUrl);
                    }
                    if (error.icon) setError((prev) => ({ ...prev, icon: "" }));
                  }}
                />
              </Button>
              <Typography
                variant="body2"
                color="text.secondary"
                className="mt-2"
              >
                Recommended size: 256x256 pixels. Maximum file size: 2MB.
                <br />
                Formats: JPG, PNG, GIF
              </Typography>
              {error.icon && (
                <Typography variant="caption" color="error" display="block">
                  {error.icon}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sx={{ display: "flex", gap: 2 }}>
              <FormControlLabel
                control={
                  <CustomSwitch
                    checked={isRequired}
                    onChange={() => setIsRequired(!isRequired)}
                  />
                }
                label="Required"
              />
              <FormControlLabel
                control={
                  <CustomSwitch
                    checked={isActive}
                    onChange={() => setIsActive(!isActive)}
                  />
                }
                label="Active"
              />
            </Grid>
          </Grid>
          <Divider sx={{ my: 2 }} />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            {/* <Button
              variant="outlined"
              onClick={() => dispatch({ type: CLOSE_DIALOGUE })}
            >
              Cancel
            </Button> */}
            <HandleButton
              btnName="Cancel"
              btnColor="myCustomButton"
              style={{ borderRadius: "5px", width: "80px" }}
              onClick={() => dispatch({ type: CLOSE_DIALOGUE })}
            />
            {/* <Button type="submit" variant="contained" >
              {mongoId ? "Update" : "Submit"}
            </Button> */}
            <HandleButton
              btnName={mongoId ? "Update" : "Submit"}
              btnColor="btnBlackPrime text-light"
              style={{ borderRadius: "5px", width: "80px" }}
              newClass="me-2"
              onClick={handleSubmit}
            />
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AttributeDialog;
